export default function Footer() {
  return (
    <footer id="footer" className="py-0 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pb-4">
        <div className="bg-foreground-900 rounded-[32px] overflow-hidden p-8 md:p-12 lg:p-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            <div className="md:col-span-1">
              <h3 className="font-heading text-[22px] text-background-50 mb-4">51吃瓜网</h3>
              <p className="text-sm text-foreground-300 leading-relaxed mb-6">
                吃瓜爆料第一站，全网最快最全的吃瓜平台。为您提供最新娱乐资讯、网红事件、黑料网曝等热门内容，带您轻松吃瓜，掌握最新八卦动态。
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-tiktok-line text-background-50"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-3">
                <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }} className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">首页</a>
                <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }} className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">吃瓜索引</a>
                <a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }} className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">今日热瓜榜</a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }} className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">爆料投稿</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">联系我们</h4>
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-mail-line"></i>
                  <span>tips@51chigua.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-phone-line"></i>
                  <span>400-888-5151</span>
                </div>
                <div className="text-sm text-foreground-400 mt-2 leading-relaxed">
                  北京市朝阳区望京SOHO<br />T1栋A座1208室
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-xs text-foreground-400">
              &copy; 2023-2026 51吃瓜网 版权所有
            </div>
            <div className="flex gap-6">
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}